<script setup>
import ServiceImportGrid from '@/components/registry/ServiceImportGrid.vue'

</script>
<template>
  <service-import-grid />
</template>
